import { EmpreenderApps } from '../lib/AppsArray';

const normalizeAppKey = (value: string) =>
	value
		.trim()
		.toLowerCase()
		.replace(/[^a-z0-9]/g, '');

/**
 * Mesma ideia de match que NavigationAppsQuickAcessMenu para a chave do app atual.
 * Retorna o segmento do canal Echo alinhado ao hub: `app_key` em `data.apps` (ex.: DROPI, PLUS) — no `EmpreenderApps` isso é o campo `eplus`.
 *
 * Canal: `directNotifications.{app_key}.{userId}` (não usar `slug` em minúsculas).
 */
export function getBroadcastChannelAppKey(currentAppKey: string): string {
	const normalized = normalizeAppKey(String(currentAppKey));
	const match = EmpreenderApps.find((a) => {
		const byEplus = normalizeAppKey(a.eplus) === normalized;
		const bySlug = normalizeAppKey(a.slug) === normalized;
		const byTag = Array.isArray(a.tags) ? a.tags.some((tag) => normalizeAppKey(String(tag)) === normalized) : false;
		return byEplus || bySlug || byTag;
	});
	return match?.eplus ?? 'PLUS';
}

/** @deprecated Use {@link getBroadcastChannelAppKey} — retorna `eplus` / `app_key`, não slug. */
export const getBroadcastChannelAppSlug = getBroadcastChannelAppKey;
